import { StateService } from "@uirouter/angularjs";
import { Audit } from '../entities/Audit';
import { CustomField } from "../entities/CustomFieldName";
import { CustomFieldNameService } from "../services/CustomFieldNameService";
import { BaseService } from "./BaseService";

export class AuditService extends BaseService<Audit> {
  static $inject = ['$http', '$q', '$state', 'localStorageService', 'CustomFieldNameService'];
  constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService,
    public locStorage: angular.local.storage.ILocalStorageService,
    public customFieldNameService: CustomFieldNameService) {
    super($http, $q, $state, Audit);
  }


  protected getBaseUrl(): string {
    return "audit";
  }

  public getCustomColumnDefs(columnDefsName: string): ng.IPromise<[string, string, number][]> {
    var nvps: [string, string, number][] = this.locStorage.get<[string, string, number][]>(columnDefsName);
    if (nvps != null) {
      return this.$q.when<[string, string, number][]>(nvps);
    } else {
      return this.$q.all([
        this.customFieldNameService.getAll(),
      ]).then((data) => {
        // Parse incoming JSON
        var customFields: CustomField[] = [];
        data[0].forEach((json: any) => {
          var cfn = new CustomField(json.name, json.value, json.display, parseInt(json.displayIndex), json.uIEditable,
            json.dataType, json.handheldDisplay, json.handheldValue, parseInt(json.handheldDisplayIndex));
          customFields.push(cfn);
        });
        // Parse the custom fields into associative arrays for quick lookup
        interface IDisplayable {
          [key: string]: boolean;
        }
        interface IDisplayName {
          [key: string]: string;
        }
        var displayable: IDisplayable = {};
        var displayedName: IDisplayName = {};
        customFields.forEach((customFieldDef) => {
          var name = customFieldDef.name.replace("asset.", "");
          displayable[name] = customFieldDef.display;
          displayedName[name] = customFieldDef.value;
        });
        // Add the standard fields
        var nameValuePairs:[string, string, number][] = [
          ['eventTime', 'Event Time', 230],
          ['username', 'Username', 150],
          ['action', 'Action', 150],
          ['recordType', 'Type', 150],
          ['recordID', 'ID', 150],
          ['name', 'Name', 150],
          ['description', 'Description', 230],
          ['rfidTag', 'Rfid Tag', 150],
          ['vTagID', 'V-Tag ID', 150],
          ['vTagGpsDeviceID', 'V-Tag GPS Device ID', 230],
          ['assetType', 'Asset Type', 150],
          ['departmentCode', 'Department', 150],
          ['lastObservedLocation', 'Last Observed Location', 150],
          ['lastObservedTime', 'Last Observed Time', 230],
        ];
        // Append custom fields
        var allfields = ['text1', 'text2', 'text3', 'text4', 'text5', 'text6', 'text7', 'text8', 'text9',
          'text10', 'text11', 'text12', 'text13', 'text14', 'text15', 'text16', 'text17', 'text18', 'text19', 'text20',
          'listValue1', 'listValue2', 'listValue3', 'listValue4', 'listValue5',
          'date1', 'date2', 'date3', 'date4', 'date5'];
        allfields.forEach((field) => {
          var lcField = field.toLowerCase();
          if (displayable[lcField]) {
            nameValuePairs.push([field, displayedName[lcField], 230]);
          }
        });
        this.locStorage.set<[string, string, number][]>(columnDefsName, nameValuePairs);
        return this.$q.when<[string, string, number][]>(nameValuePairs);
      });
    }
  }
}
